import { useTranslate } from '@refinedev/core';
import { Tag, Tooltip } from 'antd';
import dayjs from 'dayjs';
import type { DateRange } from '@/api/generated/schemas';
import {
  exclusivityState,
  rangeToPickerValue,
} from '@/pages/user_catalog/publications/show/exclusivityWindow';

interface ExclusivityTagProps {
  /** Server-derived "exclusive right now". */
  isExclusive: boolean;
  ranges?: DateRange | null;
}

/**
 * Exclusivity indicator for read surfaces. Renders nothing once a window
 * has ended — a lapsed window is detail, and belongs on the Availability
 * tab rather than in a list row.
 */
export const ExclusivityTag = ({
  isExclusive,
  ranges,
}: ExclusivityTagProps) => {
  const t = useTranslate();
  const T = 'user_catalog.publications.show';
  const state = exclusivityState(ranges, dayjs());

  if (!isExclusive && state !== 'planned') return null;

  const days = rangeToPickerValue(ranges);
  const tag = (
    <Tag color={isExclusive ? 'green' : 'blue'}>
      {t('base.labels.exclusive')}
    </Tag>
  );

  if (!days) return tag;

  const upper = days[1]
    ? days[1].format('DD.MM.YYYY')
    : t(`${T}.windows.open_ended`);

  return (
    <Tooltip title={`${days[0]?.format('DD.MM.YYYY') ?? '—'} – ${upper}`}>
      {tag}
    </Tooltip>
  );
};
